function stackGet(t){return this.__data__.get(t)}module.exports=stackGet;